function Header2Mobile({ children, className }: any) {
  return <div className= {`text-custom-white font-medium tracking-[0.025em] mb-3 text-[19px] ${className}`}>{children}</div>;
}

export default Header2Mobile;
